import _Public from "@mui/icons-material/Public";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Button } from '../../components';
import { parkingNetworks } from '../../models';
function ParkingPopup({
  theme,
  parking: {
    capacity,
    sheltered,
    supervised,
    locked,
    free,
    network: networkKey,
    website,
    id
  },
  onClose,
  onSelect
}) {
  const {
    t
  } = useTranslation();
  const network = networkKey && parkingNetworks[networkKey] || null;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: t('commons.actions.close')
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), /*#__PURE__*/React.createElement(StyledHeader, null, network && /*#__PURE__*/React.createElement(StyledHeaderLogo, {
    title: network.title,
    url: network.icon
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    variant: "h6"
  }, t('commons.poi.categories.parking_one')), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexWrap: "wrap"
  }, capacity && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.racks', {
    count: capacity,
    capacity,
    context: capacity === 0 ? 'zero_long' : ''
  }), ' ', "\xA0\u2022\xA0")), locked && /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.locked'), " \xA0\u2022\xA0"), sheltered && /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.sheltered'), " \xA0\u2022\xA0"), supervised && /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.supervised'), " \xA0\u2022\xA0"), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t(free ? 'commons.parking.free' : 'commons.parking.toll'))))), website && /*#__PURE__*/React.createElement(StyledActions, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "right",
    title: t('commons.website')
  }, /*#__PURE__*/React.createElement(_IconButton, {
    color: "primary",
    component: "a",
    href: website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_Public, null)))), onSelect && /*#__PURE__*/React.createElement(StyledActions, {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => onSelect(id),
    size: "small"
  }, t('commons.actions.select')))));
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 54px 8px 16px;
`;
const StyledHeaderLogo = styled.div`
  align-self: center;
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const StyledActions = styled.div`
  flex-shrink: 0;
  padding: 0 16px 8px;

  button {
    margin-left: 8px;
  }
`;
export default ParkingPopup;